export function isTouchOnlyDevice() {
    const hasTouch =
        ("ontouchstart" in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)

    if (!hasTouch) {
        return false
    }

    const hasFinePointer = window.matchMedia("(any-pointer: fine)").matches
    const hasHover = window.matchMedia("(any-hover: hover)").matches

    return !hasFinePointer && !hasHover
}
